import React from "react";
import { Box, Typography, Grid } from "@material-ui/core";
import models from "./models";

import {
  SummaryViewBox,
  StyledSummaryImageWrapper,
  StyledSummaryInfo,
  StyledStatCard,
} from "./common.styles";

const getModelBaseOnName = (modelName, models) => {
  if (modelName.includes("K1")) {
    return models.k1;
  }
  if (modelName.includes("K3")) {
    return models.k3;
  }

  if (modelName.includes("K5 Glossy")) {
    return models.k5.submodels.glossy;
  }

  if (modelName.includes("K5 Ruggedized")) {
    return models.k5.submodels.textured;
  }
};

const AdminSummaryBox = ({ row }) => {
  const model = getModelBaseOnName(row.modelName, models);
  if (row.images.length > 4) {
    row.images.pop();
  }

  return (
    <SummaryViewBox>
      <Box height={580}>
        <StyledSummaryImageWrapper>
          {row.images.map((image, i) => (
            <Box>
              <Box
                style={{
                  backgroundImage: `url(${row.background})`,
                }}
              >
                <Box
                  style={{
                    backgroundImage: `url(${image})`,
                    position: "relative",
                  }}
                />
              </Box>
            </Box>
          ))}
        </StyledSummaryImageWrapper>
      </Box>
      <StyledSummaryInfo>
        <Typography
          variant="caption"
          style={{ textTransform: "uppercase", fontWeight: "bold" }}
        >
          Configuration Completed
        </Typography>
        <Box mt={0.3} />
        <Typography variant="h4">Here is your {model.name} robot</Typography>
        <Box mt={1} />
        <Typography>{model.copy}</Typography>
        <Box mt={1} />
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <StyledStatCard>
              <Typography variant="h3">
                {model.specs.speed ? `${model.specs.speed} mph` : "Stationary"}
              </Typography>
              <Typography variant="caption">Maximum Speed</Typography>
            </StyledStatCard>
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledStatCard>
              <Typography variant="h3">{model.specs.terrain}</Typography>
              <Typography variant="caption">Terrain Capability</Typography>
            </StyledStatCard>
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledStatCard>
              <Typography variant="h3">{model.specs.weight} lbs.</Typography>
              <Typography variant="caption">Weight</Typography>
            </StyledStatCard>
          </Grid>
          <Grid item xs={12} sm={6}>
            <StyledStatCard>
              <Typography variant="h3">{model.specs.dimensions}</Typography>
              <Typography variant="caption">Dimensions (W × H × L)</Typography>
            </StyledStatCard>
          </Grid>
        </Grid>
        <Box mt={1} />

        <Box mt={1} />
      </StyledSummaryInfo>
    </SummaryViewBox>
  );
};

export default AdminSummaryBox;
